// Single seam for post-login routing. Everyone signed in — team owner,
// member, no-team user, or admin — lands on /library (Task 12 of the admin
// revamp: the SPA no longer hosts the admin shell, so admins no longer
// auto-land on it here; they reach /admin via the avatar menu or a bookmark).
// `_me` keeps accepting the full `Me` shape (callers pass `me.me` straight
// through) even though the value is no longer inspected.
export function roleHome(_me: { isAdmin?: boolean }): string {
  return '/library';
}
